import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const EXPORT_SUCCESS_TOAST_MESSAGE_KEY = 'export-success-toast-message';

type TExportResponseHandlers = {
  redirectLocation?: string;
  searchParams?: URLSearchParams;
};

export const useExportResponseHandlers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const notify = useToastAPI();
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    ({ redirectLocation, searchParams }: TExportResponseHandlers) => {
      if (redirectLocation) {
        sessionStorage.setItem(
          EXPORT_SUCCESS_TOAST_MESSAGE_KEY,
          t('export_csv.success_message')
        );
        navigate(
          {
            pathname: redirectLocation,
            search: searchParams?.toString(),
          },
          { state: { from: location.pathname } }
        );
      } else {
        notify.error({ title: t('system_error'), duration: 5 });
      }
    },
    [navigate, notify, t, location.pathname]
  );

  const handleError = useCallback(() => {
    notify.error({ title: t('export_csv.error_message'), duration: 5 });
  }, [notify, t]);

  return { handleSuccess, handleError };
};
